import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useLazyVariant } from '@pegasus/abtesting';
import { getCookie } from '@pegasus/utils';
import { useIsEligibleForVoucher } from '@pegasus/platform-journeys';

import { useConfig } from '@browsing/config';

import { getCustomer, getHasEmailConfirmed } from '@client/redux/modules/customer';
import { useIsPlatformJourney } from '../platform-journeys';

export const useBirthdayVoucherVisibility = () => {
    const customer = useSelector(getCustomer);
    const config = useConfig();

    const isFeatureEnabledByCookie = getCookie('zl_birthday_voucher_enabled') === 'true';
    const isFeatureEnabled =
        config.isEnabled('birthday_voucher_enabled') || isFeatureEnabledByCookie;

    const isPlatformJourneyEnabled = useIsPlatformJourney();
    const isEligibleForVoucher = useIsEligibleForVoucher();
    const isMailConfirmed = useSelector(getHasEmailConfirmed);
    const location = useLocation();

    const noOtherModalIsShown = useMemo(() => {
        return (
            !isPlatformJourneyEnabled &&
            !isEligibleForVoucher &&
            (isMailConfirmed || !location.search)
        );
    }, [isPlatformJourneyEnabled, isEligibleForVoucher, isMailConfirmed, location.search]);

    const hasRequiredCustomerData = Boolean(customer?.firstName && customer?.birthday);

    const isBirthdayVoucherShown = useMemo(() => {
        return isFeatureEnabled && noOtherModalIsShown && hasRequiredCustomerData;
    }, [isFeatureEnabled, noOtherModalIsShown, hasRequiredCustomerData]);

    return { isBirthdayVoucherShown };
};
